export default __webpack_public_path__ + "static/media/aqua2.b5745100.png";